import React, { useState } from "react";
import { Button } from "../ui/Button";
import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

interface Props {
  title: React.ReactNode;
  type?: "button" | "submit" | "reset";
  onClick?: () => void; // Expect an async function for tasks
  className?: string;
  disabled?: boolean
}

const CommonButton: React.FC<Props> = ({ title, type = "button", onClick,className, disabled }) => {
  const [loading, setLoading] = useState(false); // State to handle loader visibility

  const handleClick = async () => {
    if (onClick) {
      setLoading(true); // Show loader when the task starts
      try {
        await onClick(); // Execute the provided onClick function
      } finally {
        setLoading(false); // Hide loader after task completion
      }
    }
  };

  return (
    <Button
      onClick={handleClick}
      type={type}
      className={cn(className,`relative flex h-[2.5rem] w-full items-center justify-center space-x-2 text-[.9rem] font-normal text-black transition-transform duration-200 hover:scale-105 ${
        loading ? "cursor-not-allowed opacity-70" : ""
      }`)}
      disabled={disabled || loading} // Disable button when loading
    >
      {loading ? (
        <Loader2 className="h-5 w-5 animate-spin" /> // Show loader icon
      ) : (
        <span className={className}>{title}</span> // Show b
      
      )}
    </Button>
  );
};

export default CommonButton;
